namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem3ExemptColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem3Exempt';
    }
}
